export default __webpack_public_path__ + "static/media/fuad.72e9bcb8.jpg";